import * as o from "react";
import { useKnockClient as l } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "zustand/shallow";
import { msTeamsProviderKey as v } from "../../core/utils.mjs";
import C from "../hooks/useMsTeamsConnectionStatus.mjs";
import "swr/infinite";
import "swr";
import "../../i18n/context/KnockI18nProvider.mjs";
const n = o.createContext(null), M = ({
  knockMsTeamsChannelId: t,
  tenantId: e,
  children: i
}) => {
  const m = l(), {
    connectionStatus: r,
    setConnectionStatus: c,
    errorLabel: s,
    setErrorLabel: a,
    actionLabel: u,
    setActionLabel: p
  } = C(m, t, e);
  return /* @__PURE__ */ o.createElement(n.Provider, { key: v({
    knockMsTeamsChannelId: t,
    tenantId: e,
    connectionStatus: r,
    errorLabel: s
  }), value: {
    connectionStatus: r,
    setConnectionStatus: c,
    errorLabel: s,
    setErrorLabel: a,
    actionLabel: u,
    setActionLabel: p,
    knockMsTeamsChannelId: t,
    tenantId: e
  } }, i);
}, S = () => {
  const t = o.useContext(n);
  if (!t)
    throw new Error("useKnockMsTeamsClient must be used within a KnockMsTeamsProvider");
  return t;
};
export {
  M as KnockMsTeamsProvider,
  S as useKnockMsTeamsClient
};
//# sourceMappingURL=KnockMsTeamsProvider.mjs.map
